import { DatePipe } from '@angular/common';
import { HostListener, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';
import { MdbTableDirective, MdbTablePaginationComponent, ModalDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { Subject } from 'rxjs';
import { HomologacionproductoModule } from '../../modelo/homologacionproducto/homologacionproducto.module';
import { ProductoModule } from '../../modelo/producto/producto.module';
import { ConfigetiquetaService } from '../../servicios/configetiqueta.service';
import { HomologacionService } from '../../servicios/homologacion.service';

@Component({
  selector: 'app-homologacion',
  templateUrl: './homologacion.component.html',
  styleUrls: ['./homologacion.component.css']
})
export class HomologacionComponent implements OnInit {

  
  fecha: string;
  
  lista: HomologacionproductoModule[];
  listaHomo: HomologacionproductoModule[];
  listaProductoVenta: ProductoModule[];
  listaProductoRecibo: ProductoModule[];
  
  searchText: string = '';
  cliente:string;
  producto:string;
  homologacion:HomologacionproductoModule;
  nombreProductoRecibe:string;
  nombreProductoVenta:string;
   /** control for the MatSelect filter keyword */
  public siteFilterCtrl: FormControl = new FormControl();
  searchInput = new FormControl('');
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
 
  @ViewChild(MdbTablePaginationComponent) mdbTablePaginationDet: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTableDet: MdbTableDirective;
  previous: any = [];
  @ViewChild('lgModal') public lgModal: ModalDirective;
  @ViewChild('singleSelect') singleSelect: MatSelect;
  protected _onDestroy = new Subject<void>();

  /** control for the selected bank */
  public bankCtrl: FormControl = new FormControl();

  cars = [
    { id: 1, name: 'Volvo' },
    { id: 2, name: 'Saab' },
    { id: 3, name: 'Opel' },
    { id: 4, name: 'Audi' },
];

  /** control for the MatSelect filter keyword */
  public bankFilterCtrl: FormControl = new FormControl();

  selectedPersonId = '5a15b13c36e7a7f00cf0d7cb';


  
  constructor(private sanitizer: DomSanitizer,private apiHomologar: HomologacionService,private datePipe: DatePipe,private api: ConfigetiquetaService, private ruter: Router,private alertService: AlertService,
    private config: NgSelectConfig) {
      this.config.notFoundText = 'No se encuenta';
      this.config.appendTo = 'body';
      // set the bindValue to global config when you use the same 
      // bindValue in most of the place. 
      // You can also override bindValue for the specified template 
      // by defining `bindValue` as property
      // Eg : <ng-select bindValue="some-new-value"></ng-select>
      this.config.bindValue = 'value';
  
  }

 listar()
 {

  this.searchText='';
  this.apiHomologar.listar()
    .subscribe((
      data: HomologacionproductoModule[]) => {
      this.lista = data;
      console.log(this.lista);
   
      this.mdbTable.setDataSource(this.lista);
      this.mdbTable.dataSourceChange();
      this.previous = this.mdbTable.getDataSource();
    },
    err =>  this.alertService.danger('Error no hay  conexion..')
    );

 }



  agregar(){
    this.listaHomo= [];
    this.homologacion = new HomologacionproductoModule();
  
    this.homologacion.idProductoRecibe=this.nombreProductoRecibe;
    this.listaProductoRecibo.forEach(element => {
      if (this.nombreProductoRecibe===element.m_product_id){
      this.homologacion.idProductoRecibe=element.m_product_id;
      this.homologacion.productValueRecibe=element.value;
      this.homologacion.productRecibe=element.name;
    }
    });
    this.homologacion.idProductoVende=this.nombreProductoVenta;
    this.listaProductoVenta.forEach(element => {
      if (this.nombreProductoVenta===element.m_product_id){
      this.homologacion.idProductoVende=element.m_product_id;
      this.homologacion.productValueVende=element.value;
      this.homologacion.productVende=element.name;
      }
    });
    
    this.listaHomo.push(this.homologacion);
    console.log(this.listaHomo)
    this.apiHomologar.registrar(this.listaHomo).subscribe((
      data) => {
        
        this.alertService.info("Se guardo con exito...")
        this.listar();
    },
    err => 
    this.alertService.close(err)
    
    
    );    


  }
  ngOnInit(): void {
    this.lista= [];
    this.listar();
    this.buscarProductoRecibe();
    this.buscarProductoVenta();
   
   
  }

  @HostListener('input') oninput() {
    this.searchItems();
  }
  

  eliminar(entidad:HomologacionproductoModule){
      this.apiHomologar.eliminar(entidad).subscribe((
      data) => {
      this.listar();
      this.alertService.success('Se elimino con exito...');
      },
      err => this.listar()
    );
  }

  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.lista = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.lista = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }



  buscarEtiquetas()
  {
    this.searchText='';
    this.apiHomologar.listar()
      .subscribe((
        data: HomologacionproductoModule[]) => {
        this.lista = data;
        console.log(this.lista);
     
        this.mdbTable.setDataSource(this.lista);
        this.mdbTable.dataSourceChange();
        this.previous = this.mdbTable.getDataSource();
      },
      err =>  this.alertService.danger('Error no hay  conexion..')
      );
  }

  buscarProductoRecibe()
  {
    this.searchText='';
    this.api.listarProducto()
      .subscribe((
        data: ProductoModule[]) => {
        this.listaProductoRecibo = data;
       console.log(this.listaProductoRecibo)
      },
      err =>  this.alertService.danger('Error no hay  conexion..')
      );
  }

  buscarProductoVenta()
  {
    this.searchText='';
    this.apiHomologar.listarProductoVenta()
      .subscribe((
        data: ProductoModule[]) => {
        this.listaProductoVenta = data;
        console.log(this.listaProductoVenta);
      },
      err =>  this.alertService.danger('Error no hay  conexion..')
      );
  }
  


  

}
